module.exports = __webpack_public_path__ + "assets/img/no_img_c.b7f75d9f.png";